const Permissions = {

    'SUPER_ADMIN': ['DASHBOARD', 'EQUIPMENTS', 'USERS', 'DEVICES'],

    'ADMIN': ['DASHBOARD', 'EQUIPMENTS', 'USERS', 'DEVICES'],

    'ITEGRATOR': ['DASHBOARD', 'EQUIPMENTS', 'DEVICES'],

    'OPERATOR': ['DASHBOARD', 'EQUIPMENTS'],

}

export default Permissions;



export const ROLE = {

    100: "SUPER_ADMIN",
    99: "ADMIN",
    98: "ITEGRATOR",
    97: "OPERATOR",
    
}